export default "__VITE_ASSET__fsS3v83q__"